import type { InspectorDTO } from 'src/types/dto';

import { Box } from '@mui/material';

import {
  INFO_WINDOW_STYLES,
  INFO_WINDOW_CLOSE_BUTTON_STYLES,
} from '../styles/universal-location-map.styles';

export interface MapInspectorInfoWindowProps {
  selectedMarker: InspectorDTO;
  onClose: () => void;
  onSelect: (id: number) => void;
  isSelected: boolean;
  selectButtonText: string;
}

export function MapInspectorInfoWindow({
  selectedMarker,
  onClose,
  onSelect,
  isSelected,
  selectButtonText,
}: MapInspectorInfoWindowProps) {
  const showInspectorPhone = !!selectedMarker?.phone;

  const selectButtonStyles = {
    bgcolor: isSelected ? 'primary.main' : 'grey.300',
    color: isSelected ? 'white' : 'text.primary',
    border: 'none',
    borderRadius: 1,
    px: 2,
    py: 1,
    cursor: 'pointer',
    fontSize: '0.875rem',
    fontWeight: 500,
    '&:hover': {
      opacity: 0.8,
    },
  };

  return (
    <Box sx={INFO_WINDOW_STYLES}>
      <Box display="flex" justifyContent="space-between" alignItems="flex-start">
        <Box>
          <Box fontWeight="bold">{selectedMarker.name}</Box>
          <Box fontSize="0.875rem" color="text.secondary">
            {selectedMarker.address}
          </Box>
          {showInspectorPhone && (
            <Box fontSize="0.875rem" color="text.secondary">
              {selectedMarker.phone}
            </Box>
          )}
        </Box>
        <Box onClick={onClose} sx={INFO_WINDOW_CLOSE_BUTTON_STYLES}>
          ✕
        </Box>
      </Box>

      <Box mt={1}>
        <Box component="button" onClick={() => onSelect(selectedMarker.id)} sx={selectButtonStyles}>
          {selectButtonText}
        </Box>
      </Box>
    </Box>
  );
}
